<template>
    <v-menu offset-y close-on-content-click :value="menuOpen" location="bottom">
        <template v-slot:activator="{ props }">
            <v-btn-icon density="compact" icon="$more_vert" v-bind="props" />
        </template>
        <slot> </slot>
        <v-list flat density="compact">
            <slot name="prepend-list-items"> </slot>
            <v-list-item
                @click="emitEditBtnClicked"
                v-if="!isOptionHidden('edit')"
                density="compact"
            >
                <template #append>
                    <v-icon size="x-small">$fa-gear</v-icon>
                </template>

                <v-list-item-title>Editer</v-list-item-title></v-list-item
            >
            <v-list-item
                @click="emitDuplicationBtnClicked"
                v-if="!isOptionHidden('clone')"
                density="compact"
            >
                <template #append>
                    <v-icon size="x-small">$fa-clone</v-icon>
                </template>

                <v-list-item-title>Dupliquer</v-list-item-title></v-list-item
            >
            <v-list-item
                @click="emitVisibilityBtnClicked"
                v-if="!isOptionHidden('visible')"
                density="compact"
            >
                <template #append>
                    <v-icon v-if="box == null">$oss-eye</v-icon>
                    <v-icon v-else-if="box.visible">$oss-eye-slash</v-icon>
                    <v-icon v-else>$oss-eye</v-icon>
                </template>

                <v-list-item-title>
                    <span v-if="box == null">Cacher / Afficher</span>
                    <span v-else-if="box.visible">Cacher</span>
                    <span v-else>Afficher</span>
                </v-list-item-title></v-list-item
            >
            <v-list-item
                @click.stop="emitMoveToFrontClicked"
                v-if="!isOptionHidden('front')"
                density="compact"
            >
                <template #append>
                    <v-icon size="x-small">$fa-step-forward</v-icon>
                </template>

                <v-list-item-title>Mettre en avant</v-list-item-title></v-list-item
            >
            <v-list-item
                @click.stop="emitMoveToBackClicked"
                v-if="!isOptionHidden('back')"
                density="compact"
            >
                <template #append>
                    <v-icon size="x-small">$fa-step-backward</v-icon>
                </template>

                <v-list-item-title>Mettre en arrière</v-list-item-title></v-list-item
            >
            <v-list-item
                @click.stop="emitMoveForwardClicked"
                v-if="!isOptionHidden('forward')"
                density="compact"
            >
                <template #append>
                    <v-icon size="x-small">$fa-forward</v-icon>
                </template>

                <v-list-item-title>Vers l'avant</v-list-item-title></v-list-item
            >
            <v-list-item
                @click.stop="emitMoveBackwardClicked"
                v-if="!isOptionHidden('backward')"
                density="compact"
            >
                <template #append>
                    <v-icon size="x-small">$fa-backward</v-icon>
                </template>

                <v-list-item-title>Vers l'arrière</v-list-item-title></v-list-item
            >
            <v-list-item
                @click="emitDeletionBtnClicked"
                v-if="!isOptionHidden('delete')"
                density="compact"
            >
                <template #append>
                    <v-icon size="x-small">$oss-trash</v-icon>
                </template>

                <v-list-item-title>Supprimer</v-list-item-title></v-list-item
            >
            <slot name="append-list-items"> </slot>
        </v-list>
    </v-menu>
</template>
<script lang="ts">
import { Box } from "./models";
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class BoxPopupMenu extends Vue {
    @Prop({ default: null }) box: Box;
    @Prop({ default: null }) hideOptions: (
        | "delete"
        | "backward"
        | "forward"
        | "back"
        | "front"
        | "visible"
        | "clone"
        | "edit"
        | string
    )[];

    menuOpen: boolean = null;

    get hiddenOptions() {
        return this.hideOptions || [];
    }

    isOptionHidden(option: string) {
        return this.hiddenOptions.indexOf(option) >= 0;
    }

    propagateEmit(event: string, ...paylaods) {
        // let vm = this as Vue;
        let vm = this as any;
        while (vm) {
            vm.$emit(event, ...paylaods);
            if (vm.$refs.boxComponent) break;
            vm = vm.$parent;
        }
    }

    emitEditBtnClicked() {
        if (this.box) {
            this.menuOpen = false;
            this.propagateEmit("edit-box", this.box);
        }
    }

    emitDuplicationBtnClicked() {
        if (this.box) {
            this.menuOpen = false;
            this.propagateEmit("duplicate-box", this.box);
        }
    }

    emitDeletionBtnClicked() {
        if (this.box) {
            this.menuOpen = false;
            this.propagateEmit("delete-box", this.box);
        }
    }

    emitMoveToFrontClicked() {
        if (this.box) {
            this.menuOpen = false;
            this.propagateEmit("move-box-to-front", this.box);
        }
    }

    emitVisibilityBtnClicked() {
        debugger;
        if (this.box) {
            this.menuOpen = false;
            this.propagateEmit("toggle-box-visibility", this.box, !this.box.visible);
        }
    }

    emitMoveToBackClicked() {
        if (this.box) {
            this.menuOpen = false;
            this.propagateEmit("move-box-to-back", this.box);
        }
    }

    emitMoveForwardClicked() {
        if (this.box) {
            this.menuOpen = false;
            this.propagateEmit("move-box-forward", this.box);
        }
    }

    emitMoveBackwardClicked() {
        if (this.box) {
            this.menuOpen = false;
            this.propagateEmit("move-box-backward", this.box);
        }
    }
}

export default toNative(BoxPopupMenu);
</script>
<style lang="css" scoped>
.v-list-item__icon {
    margin-right: 8px !important;
}
</style>
